// extracted by mini-css-extract-plugin
export var container = "_oj-0";
export var dotAnimation = "_oj-2";
export var dotsLoading = "_oj-1";